<main class="privacy-shell">
    <div class="container privacy-page">
        <header class="privacy-intro">
            <span class="privacy-eyebrow">Moony für iOS · Datenschutz</span>
            <h1>Datenschutzerklärung</h1>
            <p>
                Wie wir Daten in der iOS-App Mondkalender Moony verarbeiten
                und welche Rechte Sie haben.
            </p>
            <p class="privacy-date">Stand: 6. Oktober 2026</p>
        </header>

        <article class="privacy-content"
                 aria-label="Datenschutzinformationen für die iOS-App">

            <section>
                <h2>1. Verantwortlicher und Kontakt</h2>
                <p>Verantwortlich für die hier beschriebene Datenverarbeitung ist:</p>

                <address>
                    <strong>Freckled OG</strong><br>
                    Aberlgasse 18<br>
                    9061 Klagenfurt am Wörthersee<br>
                    Österreich
                </address>

                <p>
                    E-Mail:
                    <a href="mailto:contact&#64;freckled.dev">
                        contact&#64;freckled.dev
                    </a>
                </p>

                <p>
                    Bei Fragen zum Datenschutz oder zur Ausübung Ihrer Rechte
                    können Sie uns unter dieser Adresse kontaktieren.
                </p>
            </section>


            <section>
                <h2>2. Geltungsbereich und Überblick</h2>

                <p>
                    Diese Datenschutzerklärung beschreibt die Verarbeitung
                    personenbezogener Daten in der iOS-App Mondkalender Moony.
                </p>

                <p>
                    Für die Nutzung der App ist kein eigenes Moony-Benutzerkonto
                    erforderlich. Die Mondinformationen werden auf Ihrem Gerät
                    berechnet; die Empfehlungen sind Bestandteil der App.
                    Favoriten, Terminplaner und Einstellungen werden lokal
                    gespeichert und nicht automatisch als Inhalte an einen
                    Moony-Server oder an RevenueCat übertragen.
                </p>

                <p>
                    Zur Verwaltung der Pro-Funktionen werden Apple und RevenueCat
                    eingebunden. Einzelheiten hierzu finden Sie in Abschnitt 5.
                </p>
            </section>


            <section>
                <h2>3. Lokal gespeicherte Daten</h2>

                <p>
                    Die App speichert insbesondere folgende Daten im lokalen
                    App-Speicher:
                </p>

                <ul>
                    <li>
                        Ihre Favoriten als Kennungen der ausgewählten Empfehlungen.
                    </li>
                    <li>
                        Die für den Terminplaner ausgewählten Aufgaben und die
                        zugehörigen Erledigungsdaten.
                    </li>
                    <li>
                        Darstellungs-, Sortier- und Filtereinstellungen,
                        beispielsweise Design, Kategorien und Anzahl der Textzeilen.
                    </li>
                    <li>
                        Die von Ihnen manuell gewählte Hemisphäre und Ihre
                        Einstellungen für Erinnerungen.
                    </li>
                    <li>
                        Technische Einstellungen, etwa zum Bewertungsdialog,
                        sowie lokal zwischengespeicherte Kauf- und
                        Abonnementinformationen.
                    </li>
                    <li>
                        Von Ihnen erzeugte PDF-Dateien mit den ausgewählten
                        Tages- oder Terminplanerinformationen.
                    </li>
                </ul>

                <p>
                    Der Suchtext wird für die lokale Suche verwendet. Die
                    Hemisphärenauswahl erfolgt manuell; hierfür wird kein
                    GPS-Standort erhoben. Die Bezeichnung „Bewertung“ in den
                    Empfehlungen beschreibt deren Eignung und ist keine
                    Erfassung Ihres Körpergewichts.
                </p>

                <p>
                    Manche Empfehlungen betreffen Körper oder Gesundheit.
                    Ihre Auswahl und Erledigungsdaten können daher entsprechende
                    Interessen oder Aktivitäten erkennen lassen. Diese Inhalte
                    werden durch die beschriebenen Kernfunktionen nicht
                    automatisch an uns übermittelt.
                </p>

                <p>
                    Die lokale Verarbeitung dient der Bereitstellung der von
                    Ihnen genutzten App-Funktionen. Soweit hierbei
                    personenbezogene Daten verarbeitet werden und die
                    Verarbeitung zur Erfüllung des Nutzungsvertrags erforderlich
                    ist, erfolgt sie auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO.
                </p>
            </section>


            <section>
                <h2>4. Berechtigungen und Erinnerungen</h2>

                <p>
                    Für Erinnerungen an Aufgaben oder Mondereignisse fragt die
                    App die iOS-Berechtigung für Mitteilungen mit Hinweisen und
                    Ton ab. Die Erinnerungen werden lokal auf Ihrem Gerät geplant
                    und von iOS angezeigt; hierfür nutzt die App keinen eigenen
                    Remote-Push-Dienst.
                </p>

                <p>
                    Aufgabenbezeichnungen können im Inhalt einer Erinnerung
                    erscheinen. Je nach Ihren iOS-Einstellungen können diese
                    auch auf dem Sperrbildschirm sichtbar sein. Sie können
                    Erinnerungen in der App konfigurieren und die
                    Mitteilungsberechtigung jederzeit in den iOS-Einstellungen
                    entziehen.
                </p>

                <p>
                    Die iOS-Systemfreigabe steuert die technische Berechtigung
                    für Mitteilungen und ist nicht automatisch eine Einwilligung
                    in andere Datenverarbeitungen. Die lokale Planung erfolgt
                    zur Bereitstellung der von Ihnen gewünschten
                    Erinnerungsfunktion, soweit erforderlich auf Grundlage von
                    Art. 6 Abs. 1 lit. b DSGVO.
                </p>

                <p>
                    Die App fordert keinen Zugriff auf Ihren Standort, Ihre
                    Kontakte, Ihren persönlichen Systemkalender, Ihre
                    System-Erinnerungen, Kamera, Mikrofon, Fotomediathek oder
                    HealthKit an. Der Kalender und der Terminplaner innerhalb
                    von Moony sind app-eigene Funktionen.
                </p>
            </section>


            <section>
                <h2>5. In-App-Käufe und Abonnements</h2>

                <h3>Apple App Store</h3>

                <p>
                    Pro-Abonnements werden als In-App-Käufe über Apple
                    abgewickelt. Apple verarbeitet dabei die für den Kauf
                    erforderlichen Zahlungs- und Transaktionsdaten nach Maßgabe
                    der eigenen Datenschutzbestimmungen. Wir erhalten keine
                    vollständigen Kreditkarten- oder Bankdaten und keine
                    Zugangsdaten Ihrer Apple-ID.
                </p>

                <p>
                    Weitere Informationen finden Sie in den
                    <a href="https://www.apple.com/legal/privacy/de-ww/">
                        Datenschutzinformationen von Apple
                    </a>.
                </p>


                <h3>Abonnementverwaltung mit RevenueCat</h3>

                <p>
                    Zur Verwaltung der Pro-Funktionen verwenden wir RevenueCat
                    (RevenueCat, Inc.). RevenueCat hilft uns dabei, Käufe
                    und Abonnements zu prüfen, Pro-Funktionen freizuschalten
                    und bestehende Käufe wiederherzustellen.
                </p>

                <p>
                    Dabei können eine pseudonyme Nutzerkennung, technische
                    Geräte- und App-Informationen, Ihre IP-Adresse sowie
                    Informationen zu Käufen und Abonnements verarbeitet werden.
                    Dazu gehören beispielsweise das gekaufte Produkt,
                    Kauf- und Ablaufzeitpunkte sowie der aktuelle
                    Abonnementstatus.
                </p>

                <p>
                    RevenueCat wird bereits beim Start der App verwendet, damit
                    ein bestehender Pro-Status erkannt und korrekt bereitgestellt
                    werden kann. Dabei werden keine Favoriten,
                    Terminplanereinträge, Suchtexte, Namen, E-Mail-Adressen oder
                    Kontaktdaten aus Moony an RevenueCat übermittelt.
                </p>

                <p>
                    Die Verarbeitung erfolgt zur Abwicklung von Käufen und zur
                    Bereitstellung erworbener Pro-Funktionen auf Grundlage von
                    Art. 6 Abs. 1 lit. b DSGVO. Soweit darüber hinaus eine
                    technische Statusprüfung für den zuverlässigen Betrieb der
                    Abonnementverwaltung erforderlich ist, erfolgt die
                    Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
                    Unser berechtigtes Interesse besteht darin, erworbene
                    Pro-Berechtigungen zuverlässig zu erkennen und
                    bereitzustellen.
                </p>


                <h3>Datenverarbeitung durch RevenueCat</h3>

                <p>
                    RevenueCat wird für diese Zwecke als Auftragsverarbeiter
                    eingesetzt. Daten können dabei auch in den USA verarbeitet
                    werden. Für entsprechende Übermittlungen außerhalb des
                    Europäischen Wirtschaftsraums sieht das Data Processing
                    Addendum von RevenueCat insbesondere die
                    Standardvertragsklauseln der Europäischen Kommission vor.
                </p>

                <p>
                    Weitere Informationen finden Sie in der
                    <a href="https://www.revenuecat.com/privacy/">
                        Datenschutzerklärung von RevenueCat
                    </a>
                    und im
                    <a href="https://www.revenuecat.com/dpa/">
                        Data Processing Addendum von RevenueCat
                    </a>.
                </p>
            </section>


            <section>
                <h2>6. Werbung, Tracking und Diagnose</h2>

                <p>
                    In der iOS-App ist kein Werbenetzwerk und kein separates
                    allgemeines Nutzungsanalyse- oder Crash-Reporting-SDK aktiv
                    eingebunden. Es wird kein Tracking-Dialog über Apples
                    App Tracking Transparency angefordert. Dies bedeutet nicht,
                    dass keine technischen Daten verarbeitet werden:
                    Die Abonnementintegration ist in Abschnitt 5 beschrieben.
                </p>

                <p>
                    Die App kann lokale technische Diagnosemeldungen über die
                    Systemprotokollierung ausgeben. Ein eigener automatischer
                    Upload dieser App-Protokolle ist nicht vorgesehen.
                    Für Diagnosefunktionen von iOS gelten Ihre
                    Apple-Einstellungen und die Datenschutzinformationen
                    von Apple.
                </p>
            </section>


            <section>
                <h2>7. PDF-Erstellung, Teilen und Drucken</h2>

                <p>
                    Wenn Sie eine PDF-Ausgabe erstellen, werden die ausgewählten
                    Tagesinformationen oder Terminplanereinträge lokal
                    verarbeitet. Die PDF-Datei wird im Dokumentenverzeichnis
                    der App gespeichert und nicht automatisch an einen
                    Moony-Server hochgeladen. Für diese Dateien ist in der App
                    keine automatische Löschfrist eingerichtet.
                </p>

                <p>
                    Über die iOS-Teilen-Funktion können Sie Dateien an selbst
                    gewählte Apps, Empfänger, Dateispeicher oder Drucker
                    weitergeben. Erst durch Ihre jeweilige Auswahl wird die
                    Datei an das betreffende Ziel übergeben. Für die dortige
                    Verarbeitung gelten zusätzlich die Bedingungen und
                    Datenschutzinformationen des gewählten Dienstes.
                    Exportierte Kopien werden durch eine spätere Löschung in
                    Moony nicht automatisch entfernt.
                </p>

                <p>
                    Diese Verarbeitung dient der von Ihnen angeforderten
                    Export- oder Druckfunktion und erfolgt, soweit
                    personenbezogene Daten verarbeitet werden und die
                    Verarbeitung vertraglich erforderlich ist, auf Grundlage
                    von Art. 6 Abs. 1 lit. b DSGVO.
                </p>
            </section>


            <section>
                <h2>8. Kontakt und Support</h2>

                <p>
                    Die Kontaktfunktion öffnet Ihre E-Mail-App mit einem Entwurf
                    an
                    <a href="mailto:contact&#64;freckled.dev">
                        contact&#64;freckled.dev
                    </a>.
                    Der vorbelegte Betreff enthält die App-Version, die
                    Buildnummer und gegebenenfalls den Hinweis auf den
                    Pro-Status. Die Nachricht wird nicht automatisch versendet.
                    Text und eventuelle Anhänge bestimmen Sie selbst.
                </p>

                <p>
                    Wenn Sie uns schreiben, verarbeiten wir Ihre
                    Absenderadresse, den Nachrichteninhalt, beigefügte Dateien
                    und die für die Bearbeitung erforderlichen
                    Kommunikationsdaten. Bitte senden Sie nur die für Ihr
                    Anliegen notwendigen Informationen und möglichst keine
                    sensiblen Gesundheitsinformationen.
                </p>

                <p>
                    Soweit Ihre Anfrage ein Vertragsverhältnis, einen Kauf oder
                    die Nutzung der App betrifft, erfolgt die Verarbeitung auf
                    Grundlage von Art. 6 Abs. 1 lit. b DSGVO. Bei sonstigen
                    Anfragen erfolgt die Verarbeitung auf Grundlage von
                    Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse
                    besteht darin, Ihre Anfrage zu bearbeiten und zu beantworten.
                </p>
            </section>


            <section>
                <h2>9. Speicherdauer und Löschung</h2>

                <p>
                    Lokal gespeicherte Favoriten und Terminplanereinträge bleiben
                    grundsätzlich erhalten, bis Sie sie in der App entfernen
                    oder die App einschließlich ihrer Daten löschen.
                    Das Zurücksetzen von Einstellungen löscht nicht automatisch
                    Favoriten, Terminplaner oder PDF-Dateien.
                </p>

                <p>
                    Gerätesicherungen können abhängig von Ihren iOS- und
                    Backup-Einstellungen Kopien der App-Daten enthalten.
                    Eine eigene Moony-Cloud-Synchronisierung ist nicht
                    eingerichtet. Bereits erstellte Backups oder exportierte
                    Dateien müssen bei Bedarf gesondert gelöscht werden.
                </p>

                <p>
                    Eine Deinstallation beendet oder kündigt kein
                    Apple-Abonnement und löscht nicht automatisch serverseitige
                    Kauf- oder Abonnementdaten. Abonnements verwalten Sie über
                    Ihren Apple-Account.
                </p>

                <p>
                    Daten, die durch RevenueCat in unserem Auftrag verarbeitet
                    werden, werden entsprechend dem jeweiligen
                    Verarbeitungszweck und den für unser Vertragsverhältnis mit
                    RevenueCat geltenden Vereinbarungen gespeichert und
                    gelöscht. Eine längere Aufbewahrung kann insbesondere
                    erforderlich sein, soweit Daten zur Abwicklung oder
                    Wiederherstellung von Käufen, zur Erfüllung gesetzlicher
                    Pflichten oder zur Geltendmachung oder Abwehr von
                    Rechtsansprüchen benötigt werden.
                </p>

                <p>
                    Supportanfragen speichern wir grundsätzlich nur so lange,
                    wie dies für die Bearbeitung und Beantwortung der Anfrage
                    erforderlich ist. Eine längere Speicherung kann erfolgen,
                    wenn gesetzliche Aufbewahrungspflichten bestehen oder die
                    Daten zur Geltendmachung oder Abwehr von Rechtsansprüchen
                    erforderlich sind.
                </p>

                <p>
                    Soweit gesetzliche Aufbewahrungspflichten bestehen, erfolgt
                    die entsprechende Verarbeitung auf Grundlage von
                    Art. 6 Abs. 1 lit. c DSGVO. Anfragen zur Löschung von durch
                    uns oder in unserem Auftrag verarbeiteten Daten können Sie
                    an die in Abschnitt 1 genannte Kontaktadresse richten.
                </p>
            </section>


            <section>
                <h2>10. Ihre Rechte</h2>

                <p>
                    Unter den jeweiligen gesetzlichen Voraussetzungen haben Sie
                    insbesondere das Recht auf:
                </p>

                <ul>
                    <li>
                        Auskunft über die Verarbeitung Ihrer personenbezogenen
                        Daten (Art. 15 DSGVO).
                    </li>
                    <li>
                        Berichtigung unrichtiger Daten (Art. 16 DSGVO).
                    </li>
                    <li>
                        Löschung Ihrer Daten (Art. 17 DSGVO).
                    </li>
                    <li>
                        Einschränkung der Verarbeitung (Art. 18 DSGVO).
                    </li>
                    <li>
                        Datenübertragbarkeit bei hierfür geeigneten
                        Verarbeitungen (Art. 20 DSGVO).
                    </li>
                    <li>
                        Widerruf einer erteilten datenschutzrechtlichen
                        Einwilligung mit Wirkung für die Zukunft
                        (Art. 7 Abs. 3 DSGVO).
                    </li>
                </ul>

                <p>
                    <strong>Widerspruch:</strong>
                    Beruht eine Verarbeitung auf Art. 6 Abs. 1 lit. f DSGVO,
                    können Sie aus Gründen, die sich aus Ihrer besonderen
                    Situation ergeben, dagegen Widerspruch einlegen
                    (Art. 21 DSGVO).
                </p>

                <p>
                    Für Anfragen wenden Sie sich bitte an
                    <a href="mailto:contact&#64;freckled.dev">
                        contact&#64;freckled.dev
                    </a>.
                    Wir können nicht ohne Weiteres auf ausschließlich auf Ihrem
                    Gerät gespeicherte Daten zugreifen. Bitte übermitteln Sie
                    zur Zuordnung einer Anfrage nur notwendige Informationen;
                    niemals Ihr Apple-ID-Passwort oder vollständige
                    Zahlungsdaten.
                </p>

                <p>
                    Sie können sich außerdem bei einer
                    Datenschutzaufsichtsbehörde beschweren, insbesondere in dem
                    Mitgliedstaat Ihres gewöhnlichen Aufenthalts, Ihres
                    Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes.
                    In Österreich ist dies die
                    <a href="https://www.dsb.gv.at/">
                        Österreichische Datenschutzbehörde
                    </a>.
                </p>
            </section>


            <section>
                <h2>11. Erforderlichkeit, Sicherheit und Änderungen</h2>

                <p>
                    Die lokale Grundnutzung erfordert weder ein Moony-Konto
                    noch die Mitteilungsfreigabe. Ohne Freigabe werden die
                    betreffenden Mitteilungen nicht angezeigt. Für Kauf,
                    Wiederherstellung und Pro-Berechtigungen sind die in
                    Abschnitt 5 beschriebenen Kauf- und technischen Daten
                    erforderlich; ohne diese Verarbeitung können diese
                    Funktionen nicht zuverlässig bereitgestellt werden.
                    Supportnachrichten und das Teilen von Dateien erfolgen auf
                    Ihre Initiative.
                </p>

                <p>
                    Die App verwendet den von iOS vorgesehenen App-Speicher;
                    die Verbindung zu RevenueCat erfolgt über HTTPS.
                    Eine zusätzliche app-eigene Verschlüsselung der lokal
                    gespeicherten Inhalte wird nicht zugesichert.
                    Schützen Sie Ihr Gerät und beachten Sie insbesondere Ihre
                    Einstellungen für Backups und Mitteilungsvorschauen.
                </p>

                <p>
                    Die App trifft keine ausschließlich automatisierten
                    Entscheidungen mit rechtlicher oder ähnlich erheblicher
                    Wirkung im Sinne von Art. 22 DSGVO. Die Mondempfehlungen
                    ersetzen keine medizinische Beratung.
                </p>

                <p>
                    Bei Änderungen der App oder der Datenverarbeitung wird diese
                    Datenschutzerklärung entsprechend angepasst.
                </p>
            </section>

        </article>
    </div>
</main>
